import { defineComponent as _defineComponent } from 'vue'
import FormContainer from '@/components/molecules/form/FormContainer.vue';
import { DateInputData, SelectInputData, TextInputData } from '@/components/molecules/input/types';
import PageHeader from '@/components/molecules/page/header/PageHeader.vue';
import moment from 'moment';
import { computed, getCurrentInstance, onMounted, reactive } from 'vue';
import { DATE_FORMAT } from '../constants';
import NewRequestStepper from '../common/stepper/NewRequestStepper.vue';

type NewRequestConditionsState = {
  isLoading: boolean;
  currencies: any[];
  currentBranch: any;
}

type NewRequestConditionsForm = {
  policy_number: TextInputData;
  validity_from: DateInputData;
  validity_to: DateInputData;
  currencyId: SelectInputData;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'NewRequestConditions',
  setup(__props) {

const instance = getCurrentInstance();
const proxy = instance && instance.proxy as any;

const title = 'Crear solicitud';

const state = reactive<NewRequestConditionsState>({
  isLoading: false,
  currencies: null,
  currentBranch: proxy.$store.state.newRequest.branch
});

const form = reactive<NewRequestConditionsForm>({
  policy_number: {
    label: 'Número de Póliza',
    required: true,
    col: 3
  },
  validity_from: {
    type: "date",
    label: 'Vigencia Póliza desde',
    col: 3,
    required: true
  },
  validity_to: {
    type: "date",
    label: 'Vigencia Póliza hasta',
    required: true,
    col: 3
  },
  currencyId: {
    type: "select",
    options: [],
    label: 'Moneda',
    required: true,
    value: '',
    col: 3
  },
});

const formFields = computed(() => {
  const fieldsToReturn = {};

  Object.keys(form).forEach((key: string) => {
    if(form[key].show && !form[key].show()) return;
    fieldsToReturn[key] = form[key];
  });

  return fieldsToReturn;
});

const fieldsWithErrors = computed(() => {
  return Object.keys(form).filter((key) => !Boolean(form[key].value));
});

const isValidForm = computed(() => {
  return fieldsWithErrors.value.length === 0;
});

const prefillForm = () => {
  if (state.currencies) {
    if (state.currencies.length === 1) {
      form.currencyId.value = state.currencies[0].currencyId;
      form.currencyId.readonly = true;
    }

    form.currencyId.options = state.currencies.map((currency) => ({
      id: currency.currencyId,
      value: currency.currencyId,
      label: currency.currency.title
    }));
  }

  if (proxy.$store.state.newRequest.conditions) {
    Object.entries(proxy.$store.state.newRequest.conditions).forEach(
      ([key, value]) => {
        if (form[key] && value !== null && value !== undefined) {
          form[key] = { ...form[key], value };
        }
      }
    );
  }
};

const handleBlur = (key: string, value: string) => {
  if (key === "validity_from") {
    const fromDate = moment(value, DATE_FORMAT, true);
    const nextYearDate = fromDate.clone().add(1, 'year').format(DATE_FORMAT);
    form.validity_to.value = nextYearDate;
  }
};

const loadCurrencies = async () => {
  state.isLoading = true;
  const subscriptorId = proxy.$store.state.user.id;
  const subscriptor: any = await proxy.$root._post(
    `subscriptors/one/${subscriptorId}`,
    {
      models: 'companies',
    }
  );
  const company = subscriptor.data[0].companies[0];

  const response: any = await proxy.$root._get(
    `companiescurrencies/bycompany/${company.id}`
  );
  state.currencies = response.data.filter((currency) => currency.can_do_request);
  state.isLoading = false;
};


const prevStep = () => {
  proxy.$store.commit('changeStep', proxy.$store.state.newRequest.currentStep - 1);
  proxy.$router.push('/requests/new');
}

const nextStep = () => {
  const conditions = Object.keys(form).reduce((acc, key) => ({ ...acc, [key]: form[key].value }), {} as Record<string, any>);
  proxy.$store.commit('setNewRequestConditions', conditions);
  proxy.$store.commit('changeStep', proxy.$store.state.newRequest.currentStep + 1);
  proxy.$router.push('/requests/new/form');
}

const getFormActions = () => [
  {
    label: "Siguiente",
    disabled: !isValidForm.value,
    onClick: nextStep
  }
];

onMounted(async () => {
  state.isLoading = true;
  await Promise.all([
    loadCurrencies()
  ]);
  prefillForm();
  state.isLoading = false;
});

return { __sfc: true,instance, proxy, title, state, form, formFields, fieldsWithErrors, isValidForm, prefillForm, handleBlur, loadCurrencies, prevStep, nextStep, getFormActions, FormContainer, PageHeader, NewRequestStepper }
}

})